import { ApplicationState } from "..";
import { Action, Store, Dispatch, AnyAction } from "redux";
import { SEND_KEYBOARD_VALUE } from "./constants";
import { PressedKeyboardButtonAction } from "./type";
import { pressedKeyboardButton } from "./actions";

const keyboardService = (store: Store<ApplicationState>) => (next: Dispatch<AnyAction>) => (action: Action) => {
    switch (action.type) {
        case SEND_KEYBOARD_VALUE:
            const mask = store.getState().keyboard.mask;
            let value = (action as PressedKeyboardButtonAction).payload.value;
            if (mask === "#") {
                // expect only numbers string. Not special characters of letters.
                const tempValue = value.split("");
                value = tempValue.filter(val => /^\d+$/.test(val)).join("");
            } else if (mask && mask.length > 0 && value.length > 0) {
                value = filterMask(value, mask);
            }
            store.getState().keyboard.pipe(value);
            next(pressedKeyboardButton(value));
            break;
        default:
            next(action);
    }
};

function filterMask(value: string, mask: string): string {
    const valueArray = value.toUpperCase().split("");
    const maskArray = mask.replace(/\s|\(|\)|_|-|\+/g, "").split("");
    const valueReturn = [];
    for (let i = 0; i < maskArray.length && i < valueArray.length; i++) {
        let addToValueReturn = false;
        let continueParsing = false;
        switch (maskArray[i]) {
            case "A":
                addToValueReturn = valueArray[i].charCodeAt(0) >= 65 && valueArray[i].charCodeAt(0) <= 90;
                break;
            case "a":
                addToValueReturn = valueArray[i].charCodeAt(0) >= 97 && valueArray[i].charCodeAt(0) <= 122;
                break;
            case "1":
                addToValueReturn = valueArray[i].charCodeAt(0) >= 48 && valueArray[i].charCodeAt(0) <= 57;
                break;
            default:
                continueParsing = true;
        }
        if (addToValueReturn) {
            valueReturn.push(valueArray[i]);
        }
        if (!addToValueReturn && !continueParsing) {
            break;
        }
    }
    return valueReturn.join("");
}
export default keyboardService;



// WEBPACK FOOTER //
// ./src/store/Keyboard/middleware.ts